import { render } from "./Cupons.vue?vue&type=template&id=46a60678&scoped=true"
import script from "./Cupons.vue?vue&type=script&lang=js"
export * from "./Cupons.vue?vue&type=script&lang=js"

import "./Cupons.vue?vue&type=style&index=0&id=46a60678&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a60678"]])

export default __exports__